import { createTheme } from '@mui/material/styles';

import components from './components';
import palette from './palette';
import typography from './typography';

export * from './variables';

export const customTheme = createTheme({
  palette,
  typography,
  components,
});
